import { Button, Card, Col, Form, Row, Select, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getCommissions } from "../../RestServices/postingService";
import { commissionGivenCategory } from "../../shared";
import AddAds from "./addComission";
import "./body.css";
import TableComponent from "./TableComponent";

const { Option } = Select;

const CommisionRates = ({ item }) => {
  const [subCategory, setSubCategory] = useState();
  const [category, setCategory] = useState();

  const [poster, setPoster] = useState([]);

  const [EditItem, setEditItem] = useState(null);

  const [edit, setEdit] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [editModal, setEditModal] = useState(false);

  const { token } = useSelector((state) => state.Authentication.user);

  useEffect(() => {
    (async () => {
      const response = await getCommissions({ subCategory, category }, token);
      if (response.rates) {
        const poster = response.rates.map((item, index) => ({
          ...item,
          key: item._id,
          sr: index,
        }));
        setPoster(poster);
      }
    })();
  }, [isModalVisible, category, edit, editModal, subCategory]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const { Title } = Typography;
  return (
    <>
      <AddAds
        isModalVisible={isModalVisible}
        showModal={showModal}
        handleOk={handleOk}
        item={null}
        handleCancel={handleCancel}
      />

      <AddAds
        isModalVisible={editModal}
        showModal={() => setEditModal(true)}
        handleOk={handleOk}
        item={EditItem}
        handleCancel={() => {
          setEditModal(false);
          setEditItem(null);
        }}
      />
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div className="p-0.5 md:p-5">
            <Card className="p-0.5 md:p-5">
              <div className="flex-between">
                <div style={{ width: "100%" }}>
                  <Row gutter={[12, 12]}>
                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                      <div className="flex-col">
                        <Title level={4} className="mb-0 text-primary">Select Category</Title>
                        <Select
                          showSearch
                          style={{ width: '100%' }}
                          placeholder="Category"
                          optionFilterProp="children"
                          onChange={setCategory}
                          filterOption={(input, option) =>
                            option.children
                              ?.toLowerCase()
                              .indexOf(input?.toLowerCase()) >= 0
                          }
                        >
                          <Option key={"asd2342"} value={null}>
                            show all
                          </Option>
                          {Object.keys(commissionGivenCategory).map((value) => (
                            <Option key={value} value={value}>
                              {value}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                      <div className="flex-col">
                        <Title level={4} className="mb-0 text-primary">Sub Category</Title>
                        <Select
                          showSearch
                          style={{ width: '100%' }}
                          placeholder="Sub Category"
                          optionFilterProp="children"
                          onChange={setSubCategory}
                          filterOption={(input, option) =>
                            option.children
                              ?.toLowerCase()
                              .indexOf(input?.toLowerCase()) >= 0
                          }
                        >
                          <Option key={"asd234asd2"} value={null}>
                            show all
                          </Option>
                          {commissionGivenCategory[category]?.value?.map(
                            (value) => (
                              <Option key={value} value={value}>
                                {value}
                              </Option>
                            ),
                          )}
                        </Select>
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="flex items-end md:justify-end">
                      <Button type="primary" className="mt-2 w-full md:w-auto" onClick={() => showModal()}>
                        Add Commission
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Card>
          </div>
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div className="p-0.5 md:p-5 ">
            <TableComponent
              setEditModal={(cond, item) => {
                setEditModal(cond);
                setEditItem(item);
              }}
              edit={edit}
              setEdit={setEdit}
              poster={poster}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default CommisionRates;
